import { Injectable } from "@angular/core";
import { IProgetto } from "app/shared/models/progetti.interface";
import { BASEMysqlService } from "./_base";
@Injectable({
  providedIn: 'root'
})
export class MysqlServiceProgetti extends BASEMysqlService {

    prefix = 'progetti_'
  
    //////////////////////////////////////////////////////////////////////////////////////////
  
    list(): Promise<any> {
      let data = {
        auth: this.getAuth(),
      }
  
      // console.log(data)
  
      return this.http.post(this.URL_BASE + this.prefix + 'list', data).toPromise();
    }
  
    get(id): Promise<any> {
      let data = {
        auth: this.getAuth(),
        id: id
      }
  
      // console.log(data)
  
      return this.http.post(this.URL_BASE + this.prefix + 'get', data).toPromise();
    }
  
    upsert(item: IProgetto): Promise<any> {
      let data = {
        auth: this.getAuth(),
        item: item
      }
  
      return this.http.post<IProgetto[]>(this.URL_BASE + this.prefix + 'upsert', data).toPromise();
    }
  
    delete(id: number): Promise<any> {
      let data = {
        auth: this.getAuth(),
        id: id
      }
  
      return this.http.post(this.URL_BASE + this.prefix + 'delete', data).toPromise();
    }
  
  }